{
	"title": "Корзина",
	"subtitle": "{count, plural, =0 {Пусто} one {# элемент} few {# элемента} many {# элементов} other {# элементов}} · хранятся 30 дней",
	"restore": "Восстановить",
	"restored": "Восстановлено",
	"emptyTrash": "Очистить корзину",
	"emptied": "Корзина очищена",
	"deleteWord": "УДАЛИТЬ",
	"actionFailed": "Не удалось выполнить действие",
	"restoreParentFirst": {
		"recording": "Сначала восстановите запись лекции",
		"material": "Сначала восстановите материал",
		"collection": "Сначала восстановите папку",
		"flashcard_set": "Сначала восстановите набор карточек"
	},
	"purgesIn": "удалится через {days, plural, one {# день} few {# дня} many {# дней} other {# дней}}",
	"relatedCount": "{count, plural, one {+# связанный элемент} few {+# связанных элемента} many {+# связанных элементов} other {+# связанных элементов}}",
	"empty": {
		"heading": "Корзина пуста",
		"description": "Удалённые материалы, записи и инструменты появятся здесь на 30 дней."
	},
	"emptyConfirm": {
		"title": "Очистить корзину?",
		"description": "Все элементы будут удалены безвозвратно. Введите УДАЛИТЬ для подтверждения."
	},
	"filter": {
		"all": "Все"
	},
	"offline": {
		"banner": "Нужен интернет, чтобы открыть корзину, восстановить или очистить.",
		"action": "Нужен интернет для этого действия",
		"emptyHeading": "Корзина недоступна офлайн"
	},
	"cascade": {
		"title": "Удалить «{title}»?",
		"withChildren": "Вместе с ним в корзину попадут:",
		"leaf": "Можно восстановить в течение 30 дней.",
		"recordingStays": "Запись лекции останется.",
		"ttl": "Можно восстановить в течение 30 дней.",
		"cancel": "Отмена",
		"confirm": "Удалить"
	},
	"entity": {
		"material": "Материал",
		"collection": "Папка",
		"note": "Конспект",
		"test": "Тест",
		"flashcard_set": "Карточки",
		"flashcard": "Карточка",
		"audio_recap": "Аудио-резюме",
		"visual_analysis": "Разбор по фото",
		"essay": "Эссе",
		"recording": "Запись лекции",
		"recording_manual_note": "Заметка к записи",
		"tutor_session": "Чат",
		"voice_session": "Голосовой репетитор",
		"study_plan": "Учебный план",
		"calendar_event": "Событие",
		"glossary_term": "Термин",
		"tutor_skill": "Навык",
		"tutor_scenario": "Сценарий"
	},
	"intro": {
		"title": "Что уходит вместе с материалом",
		"body": "Удалённый источник забирает с собой конспекты, тесты, наборы карточек и термины, собранные из него. Всё это здесь и восстанавливается.",
		"bullets": [
			"Вложенное восстанавливается только после родителя",
			"«Очистить корзину» стирает не сразу, а ночной чисткой",
			"Фильтр по типу — материалы, тесты, наборы, записи"
		]
	}
}
